$raggu_web_front_icon $mol_svg_root
	view_box \0 0 18 18
	attr *
		^
		aria-hidden \true
	sub /
		<= Stroke $mol_svg_path
			geometry <= path \
		<= Fill $mol_svg_path
			geometry <= fill \

$raggu_web_front_icon_graph $raggu_web_front_icon
	path \M2.1 5a1.9 1.9 0 1 0 3.8 0a1.9 1.9 0 1 0 -3.8 0M12.4 4.5a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0M7.4 13a2.1 2.1 0 1 0 4.2 0a2.1 2.1 0 1 0 -4.2 0M5.6 6.4 L8.2 11.2 M5.7 4.6 L12.3 4.5 M11.3 12 L13.2 6.1

$raggu_web_front_icon_chat $raggu_web_front_icon
	path \M2.6 8.2c0-2.9 2.7-4.9 6.4-4.9s6.4 2 6.4 4.9-2.7 4.9-6.4 4.9c-.8 0-1.6-.1-2.3-.3L3.4 14.6l.7-2.6c-.9-.9-1.5-2.1-1.5-3.8ZM6.4 8.1h5.2

$raggu_web_front_icon_search $raggu_web_front_icon
	path \M3.4 8a4.6 4.6 0 1 0 9.2 0a4.6 4.6 0 1 0 -9.2 0M11.5 11.6 L15.2 15.3

$raggu_web_front_icon_close $raggu_web_front_icon
	path \M4.6 4.6 L13.4 13.4 M13.4 4.6 L4.6 13.4

$raggu_web_front_icon_sliders $raggu_web_front_icon
	path \M2.6 5.4h5.1M11 5.4h4.4M2.6 12.6h3.1M9 12.6h6.4M7.7 5.4a1.7 1.7 0 1 0 3.4 0a1.7 1.7 0 1 0 -3.4 0M5.7 12.6a1.7 1.7 0 1 0 3.4 0a1.7 1.7 0 1 0 -3.4 0

$raggu_web_front_icon_sun $raggu_web_front_icon
	path \M5.9 9a3.1 3.1 0 1 0 6.2 0a3.1 3.1 0 1 0 -6.2 0M9 1.9v1.6M9 14.5v1.6M1.9 9h1.6M14.5 9h1.6M3.9 3.9l1.2 1.2M12.9 12.9l1.2 1.2M14.1 3.9l-1.2 1.2M5.1 12.9l-1.2 1.2

$raggu_web_front_icon_moon $raggu_web_front_icon
	path \M14.4 10.6A5.9 5.9 0 0 1 7.1 3.4a6.2 6.2 0 1 0 7.3 7.2Z

$raggu_web_front_icon_display $raggu_web_front_icon
	path \M4 3.4h10a1.6 1.6 0 0 1 1.6 1.6v5.4a1.6 1.6 0 0 1 -1.6 1.6h-10a1.6 1.6 0 0 1 -1.6 -1.6v-5.4a1.6 1.6 0 0 1 1.6 -1.6zM6.6 15.1h4.8M9 12v3.1

$raggu_web_front_icon_globe $raggu_web_front_icon
	path \M2.6 9a6.4 6.4 0 1 0 12.8 0a6.4 6.4 0 1 0 -12.8 0M2.7 9h12.6M9 2.6c1.8 2 2.7 4.1 2.7 6.4S10.8 13.4 9 15.4C7.2 13.4 6.3 11.3 6.3 9S7.2 4.6 9 2.6Z

$raggu_web_front_icon_chevron $raggu_web_front_icon
	path \M5.4 7 L9 10.6 L12.6 7

$raggu_web_front_icon_arrow $raggu_web_front_icon
	path \M4.4 9h9.2M9.6 5.2 13.6 9l-4 3.8

$raggu_web_front_icon_send $raggu_web_front_icon
	path \M3.2 9 15 4.2 10.6 15.2 8.6 10.4 3.2 9Z

$raggu_web_front_icon_stop $raggu_web_front_icon
	fill \M6.4 5h5.2a1.4 1.4 0 0 1 1.4 1.4v5.2a1.4 1.4 0 0 1 -1.4 1.4h-5.2a1.4 1.4 0 0 1 -1.4 -1.4v-5.2a1.4 1.4 0 0 1 1.4 -1.4z

$raggu_web_front_icon_info $raggu_web_front_icon
	path \M2.6 9a6.4 6.4 0 1 0 12.8 0a6.4 6.4 0 1 0 -12.8 0M9 8.2v4.1
	fill \M8.15 5.7a.85 .85 0 1 0 1.7 0a.85 .85 0 1 0 -1.7 0

$raggu_web_front_icon_sources $raggu_web_front_icon
	path \M3.2 4.6a1.6 1.6 0 0 1 1.6-1.6H8l1.4 1.7h4a1.4 1.4 0 0 1 1.4 1.4v1.1M2.9 7.4h12.7l-1.3 6a1.4 1.4 0 0 1-1.4 1.1H4.7a1.4 1.4 0 0 1-1.4-1.2Z

$raggu_web_front_icon_sweep $raggu_web_front_icon
	path \M11.6 2.8 8.2 6.2M6.4 5.1 12.9 11.6 10.8 13.7 4.3 7.2ZM3.1 14.9h4.4

$raggu_web_front_icon_plus $raggu_web_front_icon
	path \M9 4.2v9.6M4.2 9h9.6

$raggu_web_front_icon_recentre $raggu_web_front_icon
	path \M3 6.2V4.3a1.3 1.3 0 0 1 1.3-1.3H6.2M11.8 3h1.9A1.3 1.3 0 0 1 15 4.3v1.9M15 11.8v1.9a1.3 1.3 0 0 1-1.3 1.3h-1.9M6.2 15H4.3A1.3 1.3 0 0 1 3 13.7v-1.9M7 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0

$raggu_web_front_icon_caret $raggu_web_front_icon
	view_box \0 0 12 12
	path \M2 4.5 L6 8.5 L10 4.5

$raggu_web_front_icon_mol $raggu_web_front_icon
	path \M12.6 5.4a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M3 5.4a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M7.8 1.8a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M7.8 9a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M12.6 12.6a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M7.8 16.2a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M3 12.6a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M0.6 9a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M15 9a1.2 1.2 0 1 0 2.4 0a1.2 1.2 0 1 0 -2.4 0M5.16 6.12L8.04 8.28M5.16 4.68L8.04 2.52M9.96 2.52L12.84 4.68M9 3L9 7.8M9.96 9.72L12.84 11.88M9 10.2L9 15M12.84 13.32L9.96 15.48M8.04 15.48L5.16 13.32
